module.exports = __webpack_public_path__ + "static/SH-Disinfection-Web-Circle-AU-a2937932ebc9367a14d68d3b59170f70.png";